
import HMore from '@/Sections/Dashboard/More'

export default {
  components: {
    HMore,
  },

  data: () => ({
    more: {
      show: false,
      x: 0,
      y: 0,
      free: true,
      id: 0,
    },
  }),

  methods: {
    showMore (payload) {
      const ev = payload.event
      ev.preventDefault()
      this.more.show = false
      this.more.x = ev.clientX
      this.more.y = ev.clientY
      this.more.free = payload.free
      this.more.id = payload.id
      this.$nextTick(() => {
        this.more.show = true
      })
    },
  },
}
